import {Component} from 'react';
import {Col, Input, Row} from "reactstrap";
import TextLabel from "../../../../../Controls/TextLabel.mjs";
import Glob from "../../../../../libs/Glob.mjs";

const AvvisiEditorSubject = class extends Component {
	constructor(props) {
		super(props);
		this.state = { value: props.message?.subject || '' };
		this.onChange = this.onChange.bind(this);
	}
	onChange = (v) => {
		v = v.target.value || '';
		const m = this.props.getter();
		m.subject = v;
		this.setState( { value: v, message: m });
		this.props.setter( m );
	};
	render() {
		return(
			<Row className={ this.props.error ? 'textinput error': 'textinput'}>
				<Col className={"nomobile"}>
					<TextLabel value={"Subject"} />
				</Col>
				<Col>
					<Input
						placeholder={ Glob.label('Subject') }
						type="text"
						value={ this.state.value }
						onChange={ this.onChange }
					/>
				</Col>
			</Row>
		)
	}
};

export default AvvisiEditorSubject;
